import React from "react";
import { TableProps } from '../iTable';
import RadioWrapper from '../../../wui-radio/src';
import { TableInterface } from "../index";


export default function singleSelect(Table: React.ComponentClass<Partial<TableProps>> | TableInterface, _Radio: typeof RadioWrapper) {
    const SingleSelect: React.FC<TableProps> = (props) => {
        return <Table {...props} selectType={'radio'}></Table>
    };

    return SingleSelect as React.ComponentClass<Partial<TableProps>> | TableInterface;
}
